import request from '@/utils/request';
// import { getPlayParams } from '@/utils/utils';

export function verifyJoincampaign(data) {
  return request('/promotion-rest-boot/promotion/verify-join-campaign', {
    method: 'POST',
    data,
  });
}

// 查询用户通过C2C分享获取积分总数和邀请的成功人数 /promotion/C2C/user-invite-infor
export function qryUserInviteInfo(data) {
  return request('/promotion-rest-boot/promotion/C2C/user-invite-infor', {
    method: 'POST',
    data,
  });
}

// 查询用户通过C2C分享活动获取的奖品历史 /promotion/C2C/user-reward-list
// export function qryUserRewardList(data) {
//   return request('/promotion-rest-boot/promotion/C2C/user-reward-list', {
//     method: 'POST',
//     data,
//   });
// }

// 查询被分享人完成任务详情
// export function qryUserRewardDetail(data) {
//   return request('/promotion-rest-boot/promotion/referral/invitee-progress-detail', {
//     method: 'POST',
//     data,
//   });
// }

// 新增领取奖品接口/promotion/C2C/receive-reward
export function receiveReward(data) {
  return request('/promotion-rest-boot/promotion/luckyDraw/toReceivePrizes', {
    method: 'POST',
    data,
  });
}

// 分享战绩DXP
export function referralAchievementsDXP(gameCode) {
  return request(`/promotion-rest-boot/dxp/game/v1/referral-game/${gameCode}/achievements`, {
    method: 'GET',
  });
}

// 查询被邀请人列表DXP
export function qryInviteeListDXP(params) {
  return request('/promotion-rest-boot/dxp/game/v1/referral-game/invite-history', {
    method: 'GET',
    params,
  });
}

// 查询被分享人完成任务详情DXP
export function qryInviteeDetailDXP(params) {
  return request('/promotion-rest-boot/dxp/game/v1/referral-game/invite-detail', {
    method: 'GET',
    params,
  });
}

export function qrySubscribersDXP(params) {
  return request('/promotion-rest-boot/dxp/loyalty/v1/user/subscribers', {
    method: 'GET',
    params,
  });
}
